import { getPropertiesSearchParams } from '@/components/Dashboard/DashboardPendings/utils';

export const getParsedLabels = (labels, othersText) => {
  const parsedLabels = labels.map((label) =>
    label.isOthers ? { ...label, name: othersText } : label
  );

  return parsedLabels;
};

export const getHeaderUrl = (operationId, statusId, selectedIds) => {
  const tokkoBrokerHost = localStorage.getItem('tokkoBrokerHost');
  const searchParams = getPropertiesSearchParams({
    operation_types: [operationId],
    statusId,
    selectedIds,
  });

  return `${tokkoBrokerHost}/properties/?search_options=${searchParams}`;
};

export const handleClickBar = (operationId, typeId, statusId, selectedIds) => {
  const tokkoBrokerHost = localStorage.getItem('tokkoBrokerHost');
  const searchParams = getPropertiesSearchParams({
    property_types: Array.isArray(typeId) ? typeId : [typeId],
    operation_types: [operationId],
    statusId,
    selectedIds,
  });
  const url = `${tokkoBrokerHost}/properties/?search_options=${searchParams}`;
  window.open(url, '_blank');
};

export const handleTooltip = (context, labels) => {
  const labelIndex = context.dataIndex;
  const label = labels[labelIndex];

  if (!label.isOthers) {
    return `${label.name}: ${label.count}`;
  }

  if (label.isOthers && label.othersDetail) {
    const maxVisible = 12;
    const visible = label.othersDetail.slice(0, maxVisible);
    const remaining = label.othersDetail.length - maxVisible;

    const detailLines = visible.map((item) => `${item.name}: ${item.count}`);

    if (remaining > 0) {
      detailLines.push(`${remaining} more...`);
    }

    return detailLines;
  }

  return `${label.name}: ${label.count}`;
};
